/* eslint-disable react/no-danger */

"use client";

import { faCheck, faPhoneVolume, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@audacia-hq/shared/components";

import { welcomeOfferRedeem } from "../../services/api";
import { getContentFromServer } from "../../ssr/services/actions";
import Button from "../Button";
import PhoneNumberManagement from "../member-settings/PhoneNumberManagement";
import { useMember } from "../../context/MemberContext";

const WelcomeOfferActivation: React.FC = () => {
  const { t } = useTranslation(["member", "welcomeOffer"]);
  const [terms, setTerms] = useState<string>();
  const [loading, setLoading] = useState(false);
  const {
    member, isEligibleForWelcomeOffer, showWelcomeOfferModal, closeWelcomeOfferModal,
  } = useMember();
  const [modalStep, setModalStep] = useState<"TERMS" | "ADD" | "REDEEM" | "CONFIRM" | "ERROR">("TERMS");
  const [redeemError, setRedeemError] = useState<string>();

  useEffect(() => {
    if (member && !terms) getContentFromServer("member", "welcomeOffer").then((d) => setTerms(d.data.content[0].content));
  }, [member, terms]);

  useEffect(() => {
    if (!member || !isEligibleForWelcomeOffer) return;
    if (member.phoneNumbers.length > 0) setModalStep("REDEEM");
  }, []);

  const redeemWelcomeOffer = async () => {
    setLoading(true);
    const res = (await welcomeOfferRedeem()).data.promotionMutations.welcomeOfferRedeem;
    if (res.success) {
      setModalStep("CONFIRM");
    }
    //  else {
    //   setRedeemError(res.error);
    //   setModalStep("ERROR");
    // }
    setModalStep("CONFIRM");

    setLoading(false);
  };

  return (
    <>
      {member && isEligibleForWelcomeOffer && (
        <Modal
          title={modalStep === "TERMS" ? t("welcomeOffer.terms") : t("welcomeOffer.activationTitle")}
          show={showWelcomeOfferModal}
          mobileFullscreen={false}
          onClose={() => closeWelcomeOfferModal(modalStep === "CONFIRM")}
        >
          {modalStep === "TERMS" && (
            <>
              <div dangerouslySetInnerHTML={{ __html: terms }} className="pb-6" />
              <div className="flex flex-col md:flex-row-reverse pt-6 gap-3">
                <div><Button className="w-full" size="medium+" render="primary" onClick={() => setModalStep("ADD")}>{t("phoneNumber.addMyNumber")}</Button></div>
                <div><Button className="w-full" size="medium+" render="transparent" onClick={() => closeWelcomeOfferModal()}>{t("welcomeOffer:activateLater")}</Button></div>
              </div>
            </>
          )}
          {modalStep === "ADD" && (
            <>
              <PhoneNumberManagement
                defaultView="ADD"
                onSelectPhone={() => ({})}
                onAddPhone={redeemWelcomeOffer}
                onCancel={() => closeWelcomeOfferModal()}
                variant="welcomeOffer"
              />
            </>
          )}
          {modalStep === "REDEEM" && (
            <div className="flex flex-col items-center justify-center gap-6">
              <div className="p-2">
                <div className="rounded-full bg-green-600 w-[54px] h-[54px] mx-auto flex items-center justify-center">
                  <FontAwesomeIcon className="text-2xl text-white" icon={faPhoneVolume} />
                </div>
              </div>
              <div className="text-center">{t("welcomeOffer.redeem")}</div>
              <div className="w-full flex flex-col md:flex-row-reverse pt-6 gap-3">
                <div><Button className="w-full" loading={loading} size="medium+" render="primary" onClick={redeemWelcomeOffer}>{t("welcomeOffer.activate")}</Button></div>
              </div>
            </div>
          )}
          {modalStep === "CONFIRM" && (
            <div className="flex flex-col items-center justify-center gap-6">
              <div className="p-2">
                <div className="rounded-full bg-green-600 w-[54px] h-[54px] mx-auto flex items-center justify-center">
                  <FontAwesomeIcon className="text-2xl text-white" icon={faCheck} />
                </div>
              </div>
              <div className="text-center">{t("welcomeOffer.confirm")}</div>
              <div className="w-full flex flex-col md:flex-row-reverse pt-6 gap-3">
                <div><Button className="w-full" size="medium+" render="primary" onClick={() => closeWelcomeOfferModal(modalStep === "CONFIRM")}>{t("common:close")}</Button></div>
              </div>
            </div>
          )}
          {modalStep === "ERROR" && (
            <div className="flex flex-col items-center justify-center gap-6">
              <div className="p-2">
                <div className="rounded-full bg-red-600 w-[54px] h-[54px] mx-auto flex items-center justify-center">
                  <FontAwesomeIcon className="text-2xl text-white" icon={faXmark} />
                </div>
              </div>
              <div className="text-center">{t(`welcomeOffer.error.${redeemError}`)}</div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default WelcomeOfferActivation;
